import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login/'
import tag from './modules/blog/tag'
import link from './modules/blog/link'
import arquivo from './modules/blog/arquivo'
import artigo from './modules/blog/artigo'
// import resetSenha from './modules/resetSenha'
// import pedidos from './modules/pedidos'
// import pedidosAdmin from './modules/pedidos_admin'
// import sidebar from './modules/sidebar/index'

Vue.use(Vuex)

const modules = {
  login,
  tag,
  link,
  arquivo,
  artigo
  // resetSenha,
  // pedidos,
  // pedidosAdmin
  // sidebar
}

export default new Vuex.Store({
  modules
})
